'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxForm = require('redux-form');

var _applications = require('../../redux/modules/applications');

var _createAppFormValidation = require('../../utils/createAppFormValidation');

var _createAppFormValidation2 = _interopRequireDefault(_createAppFormValidation);

var _CreateAppPopup = require('@quixeltools/quixel-ui-library/dist/components/megascans/account/CreateAppPopup');

var _CreateAppPopup2 = _interopRequireDefault(_CreateAppPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CreateAppPopupContainer = (_dec = (0, _reduxForm.reduxForm)({
  form: 'createApp',
  fields: ['name', 'developer', 'icon', 'description'],
  validate: _createAppFormValidation2.default
}), _dec2 = (0, _reactRedux.connect)(null, { createApplication: _applications.createApplication }), _dec(_class = _dec2(_class = function (_React$Component) {
  (0, _inherits3.default)(CreateAppPopupContainer, _React$Component);

  function CreateAppPopupContainer(props) {
    (0, _classCallCheck3.default)(this, CreateAppPopupContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CreateAppPopupContainer.__proto__ || (0, _getPrototypeOf2.default)(CreateAppPopupContainer)).call(this, props));

    _this.state = {
      message: null,
      error: null
    };

    _this.onSubmitClick = _this.onSubmitClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(CreateAppPopupContainer, [{
    key: 'onSubmitClick',
    value: function onSubmitClick(values) {
      var _this2 = this;

      this.setState({
        message: null,
        error: null
      });

      var name = values.name,
          developer = values.developer,
          icon = values.icon,
          description = values.description;


      return this.props.createApplication({ name: name, company: developer, icon: icon, description: description }).then(function () {
        _this2.setState({
          message: 'App has been created.'
        });
      }, function (reason) {
        _this2.setState({
          error: reason.message
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$fields = _props.fields,
          nameInputProps = _props$fields.name,
          developerInputProps = _props$fields.developer,
          iconInputProps = _props$fields.icon,
          descriptionInputProps = _props$fields.description,
          handleSubmit = _props.handleSubmit,
          submitting = _props.submitting,
          childReference = _props.childReference;


      return _react2.default.createElement(_CreateAppPopup2.default, {
        icon: '/quixel_2080_logo.png',
        title: 'Create App',
        description: 'Provide following details to create an App.',

        nameInputProps: nameInputProps,
        developerInputProps: developerInputProps,
        iconInputProps: iconInputProps,
        descriptionInputProps: descriptionInputProps,

        error: this.state.error,
        message: this.state.message,
        submitting: submitting,
        onSubmit: handleSubmit(this.onSubmitClick),

        onChildRef: childReference
      });
    }
  }]);
  return CreateAppPopupContainer;
}(_react2.default.Component)) || _class) || _class);
exports.default = CreateAppPopupContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateAppContainer/CreateAppContainer.jsx
// module id = 2790
// module chunks = 0